import React, { Component } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { numberWithCommas, getStrokeColor, kmFormatter } from "../utils";
import HighchartsCustomEvents from "highcharts-custom-events";

HighchartsCustomEvents(Highcharts);
class ChannelAnalysisChart extends Component {
    state = {};
    chartComponent = React.createRef();
    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount && this.props.data && !this.props.data.nodata) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    formatMentionData(data) {
        let res = [];
        let total = Object.values(data)
            .map((x) => x.total)
            .reduce((x, y) => x + y, 0);
        for (let platform in data) {
            let platformName = this.props.allPlatforms.find((plt) => plt.id === platform);
            let shortName = platformName.short_name;
            platformName = platformName ? platformName.name : "";
            //platformName = platformName ? (platformName.name !== "Facebook Comments" ? platformName.name : "Fb comments") : "";
            let mentions = data[platform].total;
            let percentage = Math.round((data[platform].total / total) * 100);
            let color = getStrokeColor(shortName);
            res.push({
                y: mentions,
                displayY: numberWithCommas(mentions),
                totalVal: numberWithCommas(total),
                percent: percentage,
                name: platformName,
                platformId: platform,
                color: color,
            });
        }
        res = res && res.sort((a, b) => b.percent - a.percent);
        return res;
    }

    getOptions = () => {
        //  let total = this.props.data.total;
        let chartData = this.formatMentionData(this.props.data);

        let self = this;

        let chartConfig = {
            chart: {
                type: "pie",
                className: "skiptranslate",
                backgroundColor: "transparent",
                spacingTop: 0,
                spacingBottom: 5,
                spacingLeft: 0,
                spacingRight: 0,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            title: {
                text: ``,
            },
            credits: {
                enabled: false,
            },
            plotOptions: {
                pie: {
                    borderWidth: 0,
                    shadow: false,
                    showInLegend: true,
                    dataLabels: {
                        enabled: this.props.showLabel,
                        distance: "10%",
                        //format: "{point.name}: {point.displayY}",
                        formatter: function () {
                            return `<span>${this.point.name}: </span> <span>${this.point.percent}%</span>
                            `;
                        },
                        style: {
                            fontWeight: 400,
                            textOutline: "none",
                        },
                    },
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                },
            },
            legend: {
                enabled: this.props.showLegend,
                itemStyle: {
                    fontWeight: 400,
                },
                alignColumns: false,
                margin: 0,
                align: "center",
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },
            series: [
                {
                    data: chartData,
                },
            ],
            tooltip: {
                //valueSuffix: "%",
                formatter: function () {
                    return `<span>${this.point.name}</span> <br/> Mentions | <b>${this.point.percent}%  | </b></span><span><b>${numberWithCommas(
                        this.point.y,
                    )}</b> / <b>${numberWithCommas(this.point.total)}</b>`;
                },
                backgroundColor: "#fff",
                borderRadius: 6,
            },
        };
        return chartConfig;
    };

    render() {
        return (
            <HighchartsReact
                highcharts={Highcharts}
                options={this.getOptions()}
                ref={this.chartComponent}
                containerProps={{ style: { width: "100%", height: "100%" } }}
            />
        );
    }
}

export default ChannelAnalysisChart;
